import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import '../CSS/PowerBI.css';

const USDA = () => {
  const [access_token, setAccessToken] = useState('');

  useEffect(() => {
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => {
        setAccessToken(data.accessToken);
      })
      .catch((error) => {
        console.error('Error fetching PowerBI token:', error);
      });
  }, []);

  return (
    <div className="power-bi powerbi-only">
      <style>
        {`
          iframe {
            border: none;
          }
        `}
      </style>

      {access_token && (
        <PowerBIEmbed
          embedConfig={{
            type: 'report',
            id: '435e8a44-f08e-4bf1-954d-6e16ba65993a',
            embedUrl:
              'https://app.powerbi.com/reportEmbed?reportId=435e8a44-f08e-4bf1-954d-6e16ba65993a&groupId=8462ee1f-e8db-4f03-bba9-021eabab566f&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
            accessToken: access_token,
            tokenType: models.TokenType.Aad,
            pageName: 'ReportSection',
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
                
              },
              layoutType: models.LayoutType.Single,
              navContentPaneEnabled: false,
              background: models.BackgroundType.Transparent,
            },
          }}
          eventHandlers={
            new Map([
              ['loaded', function () { console.log('USDA report loaded'); }],
              ['rendered', function () { console.log('USDA report rendered'); }],
              ['error', function (event) { console.log(event.detail); }],
            ])
          }
          cssClassName="reportClass"
          getEmbeddedComponent={(embeddedReport) => {
            window.USDAReport = embeddedReport;
          }}
        />
      )}
    </div>
  );
};

export default USDA;